import { getUtmAndReferrer, getAffiliateId, buildZohoFormUrl, SourceInformation } from "@utils/campaign-tracker";
import { leadClassification } from "@utils/leadclassifier";
import React, { useEffect, useMemo, useRef, useState } from "react";

interface ZohoFormModalProps {
    onClose: () => void;
    onSuccess: () => void;
    webinarSlug: string;
}

const ZohoFormModal: React.FC<ZohoFormModalProps> = ({ onClose, onSuccess, webinarSlug }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const [campaignDetails, setCampaignDetails] = useState<SourceInformation | undefined>({});
    const [affiliateId] = useState<string | undefined>(() => getAffiliateId());

    const { utm_source, utm_medium, utm_campaign, utm_term } = leadClassification(campaignDetails?.lu, campaignDetails?.du, campaignDetails?.ru);

    const formUrl = useMemo(
        () =>
            buildZohoFormUrl(
                "https://forms.zohopublic.in/gallabox/form/Webinarondemand/formperma/PnB2QJPeGrc5sEfpC_lZrfq_p8Dkv0zM_9AOl9SP_sA",
                { utm_source, utm_medium, utm_campaign, utm_term },
                affiliateId,
                { webinar_name: webinarSlug }
            ),
        [utm_source, utm_medium, utm_campaign, utm_term, affiliateId, webinarSlug]
    );

    useEffect(() => {
        setTimeout(() => {
            setCampaignDetails({ ...getUtmAndReferrer() });
        }, 0);
    }, []);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data?.type === "formSubmitted") {
                onSuccess();
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [onSuccess]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-60" onClick={onClose} />
            <div className="relative z-10 bg-white rounded-xl shadow-xl w-full max-w-2xl">
                <button
                    onClick={onClose}
                    className="absolute text-base leading-none top-1 right-1 z-20 bg-gray-600 text-white w-7 h-7 rounded-full flex items-center justify-center hover:bg-gray-700"
                >
                    ✕
                </button>
                <iframe ref={iframeRef} src={formUrl} width="100%" height="520px" frameBorder="0" title="Zoho Form" style={{ borderRadius: "10px" }} />
            </div>
        </div>
    );
};

export default ZohoFormModal;
